import type { Notification } from '../types/notification.dto';
import type { NotificationModel } from '../types/notification.model';

export const toNotificationModel = (dto: Notification): NotificationModel => ({
	id: dto.id!,
	title: dto.content.title?.text ?? '',
	body: dto.content.body?.text ?? '',
	sentById: dto.created_by ?? '',
	sentTo: 'N/A',
	readBy: 'N/A',
	details: 'N/A',
	organizationId: dto.org_id!,
	recipients: dto.recipient_groups?.flatMap((group) => group.recipients.map((r) => r.id)) ?? [],
});
